import { getValidDomains } from './getValidDomains.js';

const opensslConfigTemplate = `
[req]
default_bits              = 4096
output_password           = {passphrase}
default_keyfile           = {primaryDomain}.key
prompt                    = no
x509_extensions           = extensions
distinguished_name        = subject

[subject]
commonName                = {primaryDomain}

[extensions]
subjectAltName            = @alternate_names

[alternate_names]
`;

export function generateOpensslConfig(options: {
  domain?: string | string[];
  passphrase?: string;
}): string | undefined {
  const { domain, passphrase = 'cloudpack' } = options;
  const domains = getValidDomains(domain);
  const primaryDomain = domains?.[0];

  if (primaryDomain) {
    let opensslConfig = opensslConfigTemplate
      .replace(/\{primaryDomain\}/g, primaryDomain)
      .replace(/\{passphrase\}/, passphrase);

    for (let i = 0; i < domains.length; i++) {
      opensslConfig += `DNS.${i + 1}                     = ${domains[i]}\n`;
    }

    return opensslConfig;
  }
}
